import { Suspense, lazy } from 'react';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorBoundary from "@/components/ErrorBoundary";

const Index        = lazy(() => import('./pages/Index'));
const About        = lazy(() => import('./pages/About'));
const Events       = lazy(() => import('./pages/Events'));
const EventDetail  = lazy(() => import('./pages/events/EventDetail'));
const Results      = lazy(() => import('./pages/Results'));
const Scholarships = lazy(() => import('./pages/Scholarships'));
const Sponsors     = lazy(() => import('./pages/Sponsors'));
const Rules        = lazy(() => import('./pages/Rules'));
const GetInvolved  = lazy(() => import('./pages/GetInvolved'));
const Support      = lazy(() => import('./pages/Support'));
const Contact      = lazy(() => import('./pages/Contact'));
const Teams        = lazy(() => import('./pages/Teams'));
const TeamDetail   = lazy(() => import('./pages/TeamDetail'));
const FormPage     = lazy(() => import('./pages/forms/FormPage'));
const FAQ          = lazy(() => import('./pages/FAQ'));
const NotFound     = lazy(() => import('./pages/NotFound'));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      retry: 1,
      retryDelay: 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: 'always',
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ErrorBoundary>
          <Suspense fallback={<div className="p-4 text-sm text-muted-foreground">Loading…</div>}>
            <Routes>
              <Route path="/"             element={<Index />} />
              <Route path="/about"        element={<About />} />
              <Route path="/events"       element={<Events />} />
              <Route path="/events/:slug" element={<EventDetail />} />
              <Route path="/results/*"    element={<Results />} />
              <Route path="/rules"        element={<Rules />} />
              <Route path="/get-involved" element={<GetInvolved />} />
              <Route path="/support"      element={<Support />} />
              <Route path="/scholarships" element={<Scholarships />} />
              <Route path="/sponsors"     element={<Sponsors />} />
              <Route path="/contact"      element={<Contact />} />
              <Route path="/teams"        element={<Teams />} />
              <Route path="/teams/:slug"  element={<TeamDetail />} />
              <Route path="/forms/:slug"  element={<FormPage />} />
              <Route path="/faq"          element={<FAQ />} />
              <Route path="*"             element={<NotFound />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
